<template>
  <div id="documentation">
    <Navigation />
    <div class="container-fixed">
      <div class="doc-services-box" style="display: flex; flex-direction: row;">
        <div class="doc-services">
          <div>
            <div class="doc-services-title animate__animated animate__fadeInLeft">다국어 현지화 서비스 제공</div>
            <ul class="service-links animate__animated animate__fadeInLeft animate__delay-1s">
              <li v-for="service in services" v-bind:key="service.id" :class="service.id == selected_service_id ? ' selected':''">
                <a href="javascript:void(0)" @click="previewService(service.id)">{{service.title}}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="doc-services-content">
          <div class="doc-localization-content-1" :style="selected_service_id == 1 ? '':'display:none'">
            <div class="doc-localization-content-1-list">
              <div class="doc-localization-content-1-row animate__animated animate__fadeInRight">
                <img src="/assets/images/localization/1/1.png" class="doc-localization-content-1-icon" alt="">
                <div class="doc-localization-content-1-details">
                  <div class="doc-localization-content-1-title">전문성</div>
                  <div class="doc-localization-content-1-desc">다양한 분야의 풍부한 경험을 가진 전문가들이 최고의 품질의 번역 서비스를 제공합니다.</div>
                </div>
              </div>
              <div class="doc-localization-content-1-row animate__animated animate__fadeInRight animate__delay-1s">
                <img src="/assets/images/localization/1/2.png" class="doc-localization-content-1-icon" alt="">
                <div class="doc-localization-content-1-details">
                  <div class="doc-localization-content-1-title">네트워크</div>
                  <div class="doc-localization-content-1-desc">언어별, 분야별 전문 인적자원으로 최고의 번역 품질을 유지합니다.</div>
                </div>
              </div>
              <div class="doc-localization-content-1-row animate__animated animate__fadeInRight animate__delay-2s">
                <img src="/assets/images/localization/1/3.png" class="doc-localization-content-1-icon" alt="">
                <div class="doc-localization-content-1-details">
                  <div class="doc-localization-content-1-title">기술</div>
                  <div class="doc-localization-content-1-desc">다양한 CAT 도구 활용 및 클라우드 번역 환경을 통해 최고의 번역 환경을 유지합니다.</div>
                </div>
              </div>
              <div class="doc-localization-content-1-row animate__animated animate__fadeInRight animate__delay-3s">
                <img src="/assets/images/localization/1/4.png" class="doc-localization-content-1-icon" alt="">
                <div class="doc-localization-content-1-details">
                  <div class="doc-localization-content-1-title">품질</div>
                  <div class="doc-localization-content-1-desc">QA 도구를 통한 언어 품질 검사와 자체 체크 리스트를 통해 오류를 최소화 합니다.</div>
                </div>
              </div>
            </div>
            <div class="doc-localization-content-1-img animate__animated animate__fadeInRight animate__delay-4s" style="background-image: url(/assets/images/localization/1/Image.png);"></div>
          </div>
          <div class="doc-localization-content-2" :style="selected_service_id == 2 ? '':'display:none'">
            <div class="service-2-map-mobile animate__animated animate__zoomIn animate__delay-2s"
              style="background-image: url('/assets/images/localization/2/Map.png');"></div>
            <div class="service-2-row">
              <div class="animate__animated animate__fadeInRight">
                <div class="service-2-order" style="color: #1090AF;">01</div>
                <div class="service-2-title" style="color: #1090AF;">아메리카</div>
                <div class="service-2-details">3개 언어 제공<br>Partner Vendor : 3개사<br>F/L 번역사 : 2~5 리소스/언어당</div>
              </div>
              <div class="animate__animated animate__fadeInRight animate__delay-1s">
                <div class="service-2-order" style="color: #6596D0;">02</div>
                <div class="service-2-title" style="color: #6596D0;">유럽</div>
                <div class="service-2-details">36개 언어 제공<br>Partner Vendor : 5개사<br>F/L 번역사 : 2~3 리소스/언어당</div>
              </div>
              <div class="animate__animated animate__fadeInRight animate__delay-2s">
                <div class="service-2-order" style="color: #0071B7;">03</div>
                <div class="service-2-title" style="color: #0071B7;">중동</div>
                <div class="service-2-details">9개 언어 제공<br>Partner Vendor : 2개사<br>F/L 번역사 : 2~3 리소스/언어당</div>
              </div>
            </div>
            <div class="service-2-map animate__animated animate__zoomIn animate__delay-2s"
              style="background-image: url('/assets/images/localization/2/Map.png');"></div>
            <div class="service-2-row">
              <div class="animate__animated animate__fadeInRight animate__delay-3s">
                <div class="service-2-order" style="color: #008ED6;">04</div>
                <div class="service-2-title" style="color: #008ED6;">아시아</div>
                <div class="service-2-details">17개 언어 제공<br>Partner Vendor : 3개사<br>F/L 번역사 : 2~5 리소스/언어당</div>
              </div>
              <div class="animate__animated animate__fadeInRight animate__delay-4s">
                <div class="service-2-order" style="color: #2EBAD6;">05</div>
                <div class="service-2-title" style="color: #2EBAD6;">아프리카</div>
                <div class="service-2-details">24개 언어 제공<br>Partner Vendor : 3개사<br>F/L 번역사 : 2~5 리소스/언어당</div>
              </div>
              <div class="animate__animated animate__fadeInRight animate__delay-5s">
                <div class="service-2-order" style="color: #005698;">06</div>
                <div class="service-2-title" style="color: #005698;">오세아니아</div>
                <div class="service-2-details">3개 언어 제공<br>Partner Vendor : 3개사<br>F/L 번역사 : 2~5 리소스/언어당</div>
              </div>
            </div>
          </div>
          <div class="doc-localization-content-3" :style="selected_service_id == 3 ? '':'display:none'">
            <div class="doc-localization-content-3-panel animate__animated animate__fadeInRight">
              <img src="/assets/images/localization/3/Phrase.png" class="doc-localization-content-3-title-img" alt="">
              <div class="doc-localization-content-3-desc">
                <p>Phrase는 텍스트리의 번역 및 현지화 기술 파트너입니다.</p>
                <p>텍스트리는 현지화 전문 번역 관리 시스템(TMS)으로 전통적인 번역 기술과 특허 받은 AI 기술을 통해 비용 효율적인 번역 서비스를 제공하고 있습니다.</p>
                <p>현지화 작업 흐름을 자동화하고, 번역 프로젝트를 관리하고, 기업용 번역 관리 시스템으로 비용 관리 및 품질 검사를 통해 엔드 투 엔드 번역 워크플로를 자동화합니다.</p>
              </div>
            </div>
            <img src="/assets/images/localization/3/doc-service-1.png" class="doc-localization-content-3-img animate__animated animate__fadeInRight animate__delay-1s" alt="">
            <img src="/assets/images/localization/3/doc-service-2.png" class="doc-localization-content-3-img animate__animated animate__fadeInRight animate__delay-2s" alt="">
            <div class="doc-localization-content-3-panel animate__animated animate__fadeInRight animate__delay-3s">
              <div class="doc-localization-content-3-title">비용 관리와 품질 관리가 가능한 중앙화 된 번역 관리 시스템</div>
              <div class="doc-localization-content-3-desc">
                <ul>
                  <li>번역 벤더, 언어 리소스 및 품질 검사를 하나의 중앙화 된 플랫폼에서 관리</li>
                  <li>자동 프로젝트 생성과 사용자 지정 가능한 워크플로우 단계 설정으로 프로젝트 완전 자동화</li>
                  <li>전문 번역가를 위한 모든 기능을 갖춘 강력한 번역 툴로 번역 생산성 향상</li>
                  <li>기계번역과 AI를 통한 비용 절감</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="doc-localization-content-4" :style="selected_service_id == 4 ? '':'display:none'">
            <div class="doc-localization-content-4-column animate__animated animate__fadeInRight">
              <img src="/assets/images/localization/4/1.png" alt="">
              <div class="doc-localization-content-4-desc">
                <p>장비 매뉴얼 / 사용자 설명서</p>
                <p>기술논문 / 특허자료</p>
                <p>교육자료 / 리포트</p>
              </div>
            </div>
            <div class="doc-localization-content-4-column animate__animated animate__fadeInRight animate__delay-1s">
              <img src="/assets/images/localization/4/2.png" alt="">
              <div class="doc-localization-content-4-desc">
                <p>소프트웨어 UI 및 UX</p>
                <p>소프트웨어 도움말, 설명서</p>
                <p>Online / Mobile Web</p>
                <p>Mobile Application</p>
              </div>
            </div>
            <div class="doc-localization-content-4-column animate__animated animate__fadeInRight animate__delay-2s">
              <img src="/assets/images/localization/4/3.png" alt="">
              <div class="doc-localization-content-4-desc">
                <p>해외 언론 보도자료</p>
                <p>이벤트 캠페인</p>
                <p>기업 호옵자료</p>
              </div>
            </div>
            <div class="doc-localization-content-4-column animate__animated animate__fadeInRight animate__delay-3s">
              <img src="/assets/images/localization/4/4.png" alt="">
              <div class="doc-localization-content-4-desc">
                <p>영상 콘텐츠 자막</p>
                <p>쇼핑몰</p>
                <p>제품 상세 페이지</p>
              </div>
            </div>
          </div>
          <div class="doc-localization-content-5" :style="selected_service_id == 5 ? '':'display:none'">
            <div class="service-4-row animate__animated animate__zoomIn">
              <div class="service-4-icon">
                <img src="/assets/images/localization/5/wired-outline-12-layers.gif" alt="">
              </div>
              <div class="service-4-order">01</div>
              <div class="service-4-details">
                <div class="service-4-title">01 의뢰 및 파일 검토</div>
                <div class="service-4-desc">분야, 파일 포맷, 대상 언어 및 작업 범위 확인</div>
              </div>
            </div>
            <div class="service-4-row service-4-row-reverse animate__animated animate__zoomIn animate__delay-1s">
              <div class="service-4-icon">
                <img src="/assets/images/localization/5/wired-outline-19-magnifier-zoom-search.gif" alt="">
              </div>
              <div class="service-4-order">02</div>
              <div class="service-4-details">
                <div class="service-4-title">02 번역 착수 준비</div>
                <div class="service-4-desc">세부 일정 수립<br>발주 파일 준비<br>언어별/분야별 전문 번역사 섭외
                </div>
              </div>
            </div>
            <div class="service-4-row animate__animated animate__zoomIn animate__delay-2s">
              <div class="service-4-icon">
                <img src="/assets/images/localization/5/wired-outline-220-arrow-9.gif" alt="">
              </div>
              <div class="service-4-order">03</div>
              <div class="service-4-details">
                <div class="service-4-title">03 번역 진행</div>
                <div class="service-4-desc">스타일가이드 및 용어집 등 참조 문서 사전 전달 및 숙지 후 작업 진행 쿼리 시트/Q&A 진행<br>일정에 따른 진행상황 확인/작업자 관리
                </div>
              </div>
            </div>
            <div class="service-4-row service-4-row-reverse animate__animated animate__zoomIn animate__delay-3s">
              <div class="service-4-icon">
                <img src="/assets/images/localization/5/wired-outline-112-book.gif" alt="">
              </div>
              <div class="service-4-order">04</div>
              <div class="service-4-details">
                <div class="service-4-title">04 리뷰 작업</div>
                <div class="service-4-desc">번역 언어 및 지역/국가에 따른 용어, 어조, 문법 등 오류 검토 및 수정 용어, 스타일, 문법 등 리뷰 진행</div>
              </div>
            </div>
            <div class="service-4-row animate__animated animate__zoomIn animate__delay-4s">
              <div class="service-4-icon">
                <img src="/assets/images/localization/5/wired-document-edit.gif" alt="">
              </div>
              <div class="service-4-order">05</div>
              <div class="service-4-details">
                <div class="service-4-title">05 DTP 문서 편집</div>
                <div class="service-4-desc">파일 변환 후 문서 및 이미지 편집<br>번역 언어 및 지역/국가의 특성에 따른 편집 실시</div>
              </div>
            </div>
            <div class="service-4-row service-4-row-reverse animate__animated animate__zoomIn animate__delay-5s">
              <div class="service-4-icon">
                <img src="/assets/images/localization/5/wired-outline-259-share-arrow.gif" alt="">
              </div>
              <div class="service-4-order">06</div>
              <div class="service-4-details">
                <div class="service-4-title">06 QA 및 납품</div>
                <div class="service-4-desc">언어/디자인 QA 실시<br>고객 납품 및 피드백 검토/반영</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BgTextree />
  </div>
</template>

<script>
import store from '@/store'

export default {
  components: {
    Navigation: () => import('@/components/nav.vue'),
    BgTextree: () => import('@/components/bg-textree.vue')
  },
  data: () => ({
    services: [
      {
        id: 1,
        title: '현지화 서비스 강점',
      },
      {
        id: 2,
        title: '글로벌 서비스 언어'
      },
      {
        id: 3,
        title: '번역 솔루션'
      },
      {
        id: 4,
        title: '서비스 제공 분야'
      },
      {
        id: 5,
        title: '현지화 프로세스'
      }
    ],
    selected_service_id: 1
  }),
  mounted() {
    store.commit('SET_NAV_PAGE', 'localization')
    store.commit('SET_NAV_THEME', 'dark')
    this.previewService(1);
  },
  methods: {
    previewService: function (id) {
      this.selected_service_id = id;
    }
  }
}
</script>
<style scoped>
.doc-services-content {
  position: relative;
}

.doc-localization-content-1 {
  position: absolute;
  margin-left: -2rem;
  display: flex;
  flex-direction: row;
  width: 150%;
}
.doc-localization-content-1-list {
  width: 50%;
}
.doc-localization-content-1-img {
  width: 100%;
  min-height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: 3rem;
}
.doc-localization-content-1-row {
  display: flex;
  flex-direction: row;
  margin-bottom: 3rem;
}
.doc-localization-content-1-row:last-child {
  margin-bottom: 0;
}
.doc-localization-content-1-icon {
  width: 60px;
  height: 60px;
  margin-right: 1rem;
}
.doc-localization-content-1-title {
  font-family: "Montserrat";
  color: #008ED6;
  font-size: 22px;
  line-height: 22px;
  margin-bottom: 1rem;
  font-weight: 700;
}
.doc-localization-content-1-desc {
  font-family: "Roboto";
  color: #000000;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 1rem;
  font-weight: 400;
}

.doc-localization-content-2 {
  margin-top: 4rem;
  font-family: 'Roboto';
}
.doc-localization-content-2 .service-2-row {
  display: flex;
  justify-content: space-around;
}
.doc-localization-content-2 .service-2-map {
  background-size: contain;
  background-position: center;
  margin: 2rem 0;
  height: 20rem;
  background-repeat: no-repeat;
}
.service-2-map-mobile {
  display: none;
}
.doc-localization-content-2 .service-2-row > div {
  position: relative;
  margin-right: 1.5rem;
}
.doc-localization-content-2 .service-2-order {
  position: absolute;
  margin-left: -3.5rem;
  margin-top: -.5rem;
  font-size: 2.5rem;
  font-weight: 700;
  font-family: 'Montserrat';
  color: #1090AF;
}
.doc-localization-content-2 .service-2-title {
  color: #1090AF;
  font-family: "Roboto";
  font-size: 25px;
  line-height: 30px;
  font-weight: 700;
  margin-bottom: .5rem;
}
.doc-localization-content-2 .service-2-details {
  color: #707070;
  font-family: "Roboto";
  font-size: 18px;
  line-height: 24px;
}

.doc-localization-content-3 {
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 1rem;
}
.doc-localization-content-3-panel:first-child {
  margin-right: 1rem;
}
.doc-localization-content-3-panel:last-child {
  margin-left: 1rem;
}
.doc-localization-content-3-title-img {

}
.doc-localization-content-3-img {
  width: 100%;
}
.doc-localization-content-3-title {
  color: #000000;
  font-family: "Roboto";
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  margin-bottom: 1rem;
}
.doc-localization-content-3-desc {
  color: #000000;
  font-family: "Roboto";
  font-size: 16px;
  line-height: 30px;
  font-weight: 400;
  margin-bottom: 1rem;
}
.doc-localization-content-3-desc ul {
  padding-left: 1.5rem;
}

.doc-localization-content-4 {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: calc(100% + 150px);
  margin-right: -150px;
  margin-left: -100px;
}
.doc-localization-content-4 img {
  width: 100%;
}
.doc-localization-content-4-column {
  text-align: center;
  margin: 1rem;
}
.doc-localization-content-4-desc {
  margin-top: 1rem;
  color: #000000;
  font-family: "Roboto";
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 1rem;
}
.doc-localization-content-4-desc p {
  margin-top: 0;
}

.doc-localization-content-5 {
  margin-top: 2rem;
  font-family: 'Roboto';
  position: relative;
}
.doc-localization-content-5 .service-4-row {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 1.5rem;
}
.doc-localization-content-5 .service-4-row-reverse {
  flex-direction: row-reverse;
}
.doc-localization-content-5 .service-4-order {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  min-width: 3.375rem;
  min-height: 3.375rem;
  background: #008ED6;
  text-align: center;
  color: white;
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: 1.4rem;
  margin: 0 2rem;
}
.doc-localization-content-5 .service-4-icon {
  width: 22rem;
  text-align: right;
}
.doc-localization-content-5 .service-4-row-reverse .service-4-icon {
  text-align: left;
}
.doc-localization-content-5 .service-4-details {
  width: 22rem;
}
.doc-localization-content-5 .service-4-icon > img {
  width: 5rem;
  height: 5rem;
}
.doc-localization-content-5 .service-4-title {
  font-weight: 600;
  font-size: 1.25rem;
  margin-bottom: 1rem;
}
.doc-localization-content-5 .service-4-row-reverse .service-4-details {
  text-align: right;
}
.doc-localization-content-5 .service-4-desc {
  color: #959595;
}
.doc-localization-content-5 .service-4-line {
  left: 50%;
  position: absolute;
  margin-top: 1rem;
  height: calc(100% - 5rem);
  width: 1px;
  background: #D9D9D9;
}

.doc-services-content {
  transform: translateX(-50px) translateY(-40px);
  width: 80%;
  display: flex;
  align-items: center;
}
.doc-services-box {
  max-width: 1600px;
  transform: translateX(100px);
  margin-top: 100px;
  margin-left: auto;
  margin-right: auto;
  height: calc(100% - 100px);
  z-index: 144;
  position: relative;
}
.doc-services {
  margin-top: -5em;
  width: 75%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.doc-services > div {
  width: calc(100% - 100px - 48px);
  padding-left: 100px;
  padding-right: 48px;
}

.doc-services-title {
  color: #008ED6;
  padding: 0 12px;
  font-family: "Montserrat";
  font-size: 22px;
  line-height: 70px;
  font-weight: bold;
}

ul.service-links {
  list-style-type: none;
  padding: 0;
}
ul.service-links li a {
  color: #CFCFCF;
  padding: 6px 12px;
  font-family: "Roboto";
  font-size: 45px;
  line-height: 70px;
  text-decoration: none;
  position: relative;
}
ul.service-links li.selected a {
  color: #2E2E2E;
}
ul.service-links li.selected a::before {
  position: absolute;
  border-top: 1px solid #707070;
  content: " ";
  width: 75px;
  top: 50%;
  left: -100px;
}

.service-preview {
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 45%);
  height: calc(100% - 100px);
  background-size: cover;
  background-position: center;
  z-index: 1;
}
.service-body {
  position: absolute;
  left: 0;
  bottom: 0;
  width: calc(75% - 48px);
  background: #008ED6;
  color: white;
  padding: 24px;
}

.service-title {
  font-family: "Nanum Gothic";
  font-size: 40px;
  font-weight: bold;
  line-height: 30px;
  padding: 24px;
}
.service-desc {
  font-family: "Nanum Gothic";
  font-size: 24px;
  font-weight: normal;
  line-height: 45px;
  padding: 0 24px;
  width: calc(75% - 12px);
}

.service-link a {
  display: inline-block;
  color: white;
  background: #F1B500;
  padding: 12px 24px;
  border-radius: 31px;
  text-decoration: none;
  z-index: 1024;
  margin: 12px 0 0;
}

@media(max-width: 1440px) {
  .doc-services-box {
    margin-top: 66px;
    height: calc(100% - 66px);
    transform: translate(0);
  }
  .doc-services-title {
    line-height: 200%;
  }
  .doc-services {
    margin-top: 0;
    width: 40%;
  }
  ul.service-links li a {
    font-size: 40px;
  }
  .doc-services-content {
    width: 60%;
  }
  .doc-localization-content-4-column {
    margin: .5rem;
  }
  .doc-localization-content-4 {
    width: 100%;
    margin-left: 0;
  }
}

@media(max-width: 1280px) {
  ul.service-links li a {
    font-size: 24px;
    line-height: 200%;
  }
  .doc-localization-content-5 .service-4-icon,
  .doc-localization-content-5 .service-4-details {
    width: 20rem;
  }
}

@media(max-width: 1024px) {
  .doc-services-box {
    flex-direction: column !important;
  }
  .doc-services {
    width: 100%;
    height: auto;
  }
  ul.service-links {
    margin: 0;
  }

  ul.service-links li a {
    font-size: 24px;
    line-height: 175%;
  }

  ul.service-links li.selected a::before {
    width: 50px;
    left: -60px;
  }
  .doc-services-content {
    width: 100%;
    padding: 64px;
    transform: translate(0);
  }

  .doc-services-content>div {
    width: calc(100% - 64px - 64px);
  }

  .doc-localization-content-1 {
    position: relative;
    margin-left: 0;
  }

  .doc-localization-content-2 {
    margin-top: 0;
  }
  .service-2-map-mobile {
    display: block;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    height: 15rem;
    width: 100%;
    margin-bottom: 2rem;
  }
  .service-2-map {
    display: none;
  }
  .doc-localization-content-2 .service-2-row {
    flex-direction: column;
  }
  .doc-localization-content-2 .service-2-row>div {
    margin-left: 3.5rem;
    margin-right: 0;
    margin-bottom: 2rem;
  }

  .doc-localization-content-3 {
    display: flex;
    flex-direction: column;
  }
  .doc-localization-content-3 > *:nth-child(3) {
    order: 4;
  }
}

@media(max-width: 768px) {
  .doc-localization-content-1-list {
    width: 100%;
  }
  .doc-localization-content-1-img {
    display: none;
  }

  .doc-localization-content-4 {
    flex-wrap: wrap;
  }
  .doc-localization-content-4-column {
    width: calc(50% - 1rem);
  }
}

@media(max-width: 640px) {
  .doc-services>div {
    padding-left: 50px;
    padding-right: 0;
    width: calc(100% - 50px);
  }
  .doc-services-content {
    width: 100%;
    margin: 24px auto;
    padding: 24px;
    transform: translate(0);
  }

  .doc-services-content>div {
    width: calc(100% - 24px - 24px);
  }

  .doc-localization-content-5 .service-4-icon {
    width: auto;
  }
}
</style>

<style>
#plusfriend-chat-button {
  bottom: 76px;
}
#plusfriend-chat-button a {
  right: -128px;
}

@media(max-width: 1440px) {
  #plusfriend-chat-button a {
    right: 12px;
  }
}

@media(max-width: 1024px) {
  #plusfriend-chat-button {
    bottom: 200px;
  }
}

@media(max-width: 576px) {
  #plusfriend-chat-button {
    bottom: 24px;
  }
}
</style>